import React, { useState } from "react";
import { Row, Col, Empty, Pagination } from "antd";
import { useTranslation } from "react-i18next";
import { TherapistCard } from "./TherapistCard";
import { TherapistPatientsModal } from "./TherapistPatientsModal";

// AHORA RECIBIMOS onUnlinkPatient
export function TherapistList({
  therapists,
  pagination,
  loading,
  onPageChange,
  onEdit,
  onDelete,
  onUnlinkPatient,
}) {
  const { t } = useTranslation("patient");

  const [showPatientsModal, setShowPatientsModal] = useState(false);
  const [selectedTherapist, setSelectedTherapist] = useState(null);

  const handleViewPatients = (therapist) => {
    setSelectedTherapist(therapist);
    setShowPatientsModal(true);
  };

  const closePatientsModal = () => {
    setShowPatientsModal(false);
    setSelectedTherapist(null);
  };

  // Wrapper para manejar la actualización visual del modal
  const handleUnlinkWrapper = async (therapistId, patientId) => {
    if (onUnlinkPatient) {
      const updatedTherapist = await onUnlinkPatient(therapistId, patientId);
      if (updatedTherapist) {
        // Actualizamos el terapeuta seleccionado para que la lista del modal cambie
        setSelectedTherapist(updatedTherapist);
      }
    }
  };

  if (!loading && therapists.length === 0) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t("terapeutas.listaVacia")}
      />
    );
  }

  return (
    <div className="therapist-list">
      <Row gutter={[24, 24]}>
        {therapists.map((therapist) => (
          <Col xs={24} sm={12} lg={8} xl={6} key={therapist._id}>
            <TherapistCard
              therapist={therapist}
              onEdit={onEdit}
              onDelete={onDelete}
              onViewPatients={handleViewPatients}
            />
          </Col>
        ))}
      </Row>

      {pagination.totalPages > 1 && (
        <div style={{ marginTop: 32, textAlign: "center" }}>
          <Pagination
            current={pagination.page}
            total={pagination.totalDocs}
            pageSize={12}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        </div>
      )}

      <TherapistPatientsModal
        visible={showPatientsModal}
        onClose={closePatientsModal}
        therapist={selectedTherapist}
        onUnlink={handleUnlinkWrapper} // Pasamos el wrapper
      />
    </div>
  );
}
